import baseApi from 'services/api/base';
import getProductKey from 'helper/requests/getProductKey';
import {
  transformGetMapDataResponse,
} from 'helper/Meteorology/Agro/CultureIndex/Area';
import { CultureIndexMapData, GetCultureIndexMapDataParams } from 'types/Meteorology/Agro/CultureIndex/Area/getMapData';
import { GetMapConfigResponse } from 'types/Meteorology/Agro/CultureIndex/Area/mapConfig';

export const cultureIndexAreaApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCultureIndexAreaMapData: build.query<CultureIndexMapData, GetCultureIndexMapDataParams>({
      query: ({
        culture,
        forecastDate,
        periodStart,
        periodEnd,
        local,
      }) => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/indice-desenvolvimento-cultura/indice-por-area/calcular/?product_key=${productKey}`,
          method: 'POST',
          body: {
            cultura: culture,
            data_rodada: forecastDate,
            data_inicial: periodStart,
            data_final: periodEnd,
            fase_fenologica: null,
            local,
          },
        };
      },
      transformResponse: transformGetMapDataResponse,
    }),
    getCultureIndexAreaMapConfig: build.query<GetMapConfigResponse, void>({
      query: () => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/indice-desenvolvimento-cultura/indice-por-area/mapas/painel-options/?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: (response: any) => response.data,
    }),
  }),
});

export const {
  useGetCultureIndexAreaMapDataQuery,
  useLazyGetCultureIndexAreaMapDataQuery,
  useGetCultureIndexAreaMapConfigQuery,
} = cultureIndexAreaApi;
